module.exports = __webpack_public_path__ + "img/PREMIERE_WATCH.b6b70081.jpg";